/**
 * @generated SignedSource<<70a0c43ca10d721a5ddb5b8be7c3693f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PLUProductImageSectionUploadLinkMutation$variables = Record<PropertyKey, never>;
export type PLUProductImageSectionUploadLinkMutation$data = {
  readonly uploadImageLink: {
    readonly image: {
      readonly id: string;
    };
    readonly url: string;
  } | null;
};
export type PLUProductImageSectionUploadLinkMutation = {
  response: PLUProductImageSectionUploadLinkMutation$data;
  variables: PLUProductImageSectionUploadLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UploadImageLinkResponse",
    "kind": "LinkedField",
    "name": "uploadImageLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUProductImageSectionUploadLinkMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PLUProductImageSectionUploadLinkMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7bfc6d9d6612151561984d16dc0ae7d5",
    "id": null,
    "metadata": {},
    "name": "PLUProductImageSectionUploadLinkMutation",
    "operationKind": "mutation",
    "text": "mutation PLUProductImageSectionUploadLinkMutation {\n  uploadImageLink {\n    image {\n      id\n    }\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e3b3fab037563a7a55d31a15c7e3ece";

export default node;
